<template>
  <q-item class="q-py-md">
    <q-item-section v-if="props.icon" avatar>
      <q-icon size="sm" :name="icon" class="op-40" />
    </q-item-section>
    <q-item-section>
      <q-item-label v-if="props.title" class="op-40 fs-80" lines="1">
        {{ props.title }}
      </q-item-label>
      <q-item-label v-if="props.subtitle" caption class="font-alt">
        {{ props.subtitle }}
      </q-item-label>
    </q-item-section>
  </q-item>
</template>
<script setup>
  const props = defineProps({
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    }
  })
</script>
